import React from 'react';
import WorkflowMultiSelect from '../../common/WorkflowMultiSelect';

const WorkflowSelector = ({
  selectedWorkflows,
  onWorkflowChange,
  allWorkflows = [],
  loading = false,
  disabled = false,
  error = false,
}) => {
  return (
    <WorkflowMultiSelect
      selectedWorkflows={selectedWorkflows}
      onWorkflowChange={onWorkflowChange}
      allWorkflows={allWorkflows}
      loading={loading}
      disabled={disabled}
      error={error}
      placeholder="Select workflows"
      helperText="Please select at least one workflow"
      showSelectAllButtons={true}
    />
  );
};

export default WorkflowSelector;
